module.exports = __webpack_public_path__ + "omniv2/img/icon-lock.d3b00727.svg";